import React, { useMemo } from 'react'
import { Box, FormHelperText, Tooltip } from '@vapor/material'
import { FormControl, FormControlProps, SxProps, Typography, Stack } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

export type FormItemProps = FormControlProps & {
  children?: JSX.Element
  fieldLabel?: React.ReactNode
  fieldTooltip?: string | JSX.Element
  fieldIcon?: React.ReactNode
  fieldEndIcon?: React.ReactNode
  errorMessage?: string
  forceLabelMargin?: boolean
}

export default function FormItem(props: FormItemProps) {
  const { fieldLabel, fieldIcon, fieldEndIcon, children, errorMessage, forceLabelMargin, fieldTooltip, ...formControlProps } = props
  const ellipsis: SxProps = { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }

  const fakeLabel = useMemo(() => {
    return forceLabelMargin ? fieldLabel ?? '-' : fieldLabel
  }, [fieldLabel, forceLabelMargin])

  const visibility = useMemo(() => {
    if (forceLabelMargin && !fieldLabel) {
      return 'hidden'
    }
    return 'visible'
  }, [forceLabelMargin, fieldLabel])

  // const tooltip = useMemo(() => {
  //   if (typeof (fieldTooltip) !== undefined) {
  //     if (typeof (fieldTooltip) === 'string') {
  //       return fieldTooltip.toString()
  //     } else {
  //       return fieldTooltip
  //     }
  //   }
  //   return ''
  // }, [fieldTooltip])

  return (
    <FormControl {...formControlProps}>
      {fakeLabel && (
        <Box component="span" display="flex" flexDirection="column">
          <Box component="div" display="flex" justifyContent="space-between" sx={{ alignItems: 'center' }}>
            <Box component="span" sx={{ flex: '1 1 auto', ...ellipsis }}>
              <Stack direction="row" alignItems="center" height={'22px'} justifyContent="space-between" maxWidth="100%">
                <Tooltip title={fieldTooltip ?? fakeLabel ?? ''} arrow placement="right" followCursor enterDelay={500} enterNextDelay={500}>
                  <Stack direction="row" spacing={1} maxWidth="100%">
                    {fieldIcon && fieldIcon}
                    <Typography noWrap variant="subtitle2" component="label" style={{ visibility: visibility, width: 'calc(100%)' }}>
                      {fakeLabel}
                    </Typography>
                    {fieldTooltip && (
                      <Box>
                        <FontAwesomeIcon icon={faCircleInfo} size="1x" height={'20px'} color="#5A6872" />
                      </Box>
                    )}
                  </Stack>
                </Tooltip>
                {fieldEndIcon ? fieldEndIcon : undefined}
              </Stack>
            </Box>
          </Box>
        </Box>
      )}
      {children}
      {errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
    </FormControl>
  )
}
